import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center" }
const _hoisted_2 = { key: 0 }

import { computed } from "vue";
import {
  ActNoOp,
  ActKeyCode,
  ActMultipleKeyCodes,
  isKeyCode,
  isMultipleKeyCodes,
} from "@/keyboard";
import { useKeycapStore } from "@/stores";
import { KeyIconDisplay, Icon as KeyIcon } from "@/stores/keycap";

type LineAccumulator = {
  text: string;
  icons: KeyIcon[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'KeyCodes',
  props: {
    action: {},
    max_length: {},
    max_lines: {},
    size_adjust: {}
  },
  setup(__props: any) {

const props = __props;

const keycap = useKeycapStore();

const display = computed(() => {
  return keycap.displayMultiple(
    isKeyCode(props.action)
      ? [props.action.KeyCode]
      : isMultipleKeyCodes(props.action)
      ? props.action.MultipleKeyCodes
      : []
  );
});

const lineSize = (line: LineAccumulator) =>
  line.text.length +
  line.icons.length * 2 +
  (line.text.length > 0 && line.icons.length > 0 ? 1 : 0);

const displayedLines = (
  lines: LineAccumulator[],
  disp: KeyIconDisplay
): LineAccumulator[] => {
  let ommited = false;

  // Try to add icon/text to a new line or one of existing ones
  const addElem = (
    sizeRequired: number,
    add: (line: LineAccumulator) => void
  ) => {
    if (sizeRequired > props.max_length) {
      ommited = true;
      return;
    }

    // First try adding as a new line
    if (lines.length < props.max_lines) {
      const line = { text: "", icons: [] };
      add(line);
      lines.push(line);
      return;
    } else {
      // Try adding to the shortest line
      const line = lines.reduce((a, b) => (lineSize(a) < lineSize(b) ? a : b));

      if (lineSize(line) + sizeRequired <= props.max_length) {
        add(line);
        return;
      }
    }

    ommited = true;
  };

  disp.icon.forEach((icon) => addElem(2, (line) => line.icons.push(icon)));

  // Sort from longest to shortest for better inserting
  disp.text.sort((a, b) => b.length - a.length);

  disp.text.forEach((text) =>
    addElem(
      text.length + 1,
      (line) => (line.text += (line.text.length > 0 ? " " : "") + text)
    )
  );

  // Finally, if nothing was added (unlikely with icons) add the first text but trimmed
  if (lines.length == 0 && disp.text.length > 0) {
    ommited = false; // no need to add it later
    const text = disp.text[0].slice(0, props.max_length - 1) + "…";
    lines.push({ text, icons: [] });
  }

  // Add 3 dots to the shortest line
  if (ommited) {
    if (lines.length == 0) lines.push({ text: "", icons: [] });
    const shortest = lines.reduce((a, b) =>
      lineSize(a) < lineSize(b) ? a : b
    );
    shortest.text += "…";
  }

  // Sort lines from shortest to longest as it looks better
  lines.sort((a, b) => lineSize(a) - lineSize(b));

  return lines;
};

const lines = computed(() => {
  const combined = {
    text: display.value.keys.text.concat(display.value.mods.text),
    icon: display.value.keys.icon.concat(display.value.mods.icon),
  };
  return displayedLines([], combined);
});

const textSize = (line: LineAccumulator, nlines: number) => {
  // const size = lineSize(line) + Math.ceil(nlines / 2);
  const size = lineSize(line) + Math.ceil(nlines / 2) - props.size_adjust;
  // console.log(size, size2);
  return Math.max(1, Math.min(size, 6));
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lines.value, (line, il) => {
      return (_openBlock(), _createElementBlock("div", {
        key: il,
        class: _normalizeClass([`text-${textSize(line, lines.value.length)}`, "flex flex-row justify-center items-center gap-1"])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.icons, (icon, ii) => {
          return (_openBlock(), _createBlock(_component_Icon, {
            key: ii,
            icon: icon.icon
          }, null, 8, ["icon"]))
        }), 128)),
        (line.text.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(line.text), 1))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})